export enum CommentType {
  Normal = 1,
  SLA = 2,
  PriceReview = 3
}
